import {
    apiTransitionVehicleDetailsForm,
    submitVehicleDetailsDataSuccess
} from '../../../actions/motorPrivateRW/carDetails';
import { getAccessToken } from '../../../selectors/motorPrivateRW/payments';
import axios from 'axios';
import { getApiQuoteResponse } from '../../../selectors/motorPrivateRW/quote';
import { getCarDetailsForm } from '../../../selectors/motorPrivateRW/carDetails';

export const saveVehicleDetailsService = (store, next, action) => {
    (async () => {
        store.dispatch(apiTransitionVehicleDetailsForm.pending());
        try {
            const resp = await saveVehicleDetails(store.getState());
            store.dispatch(submitVehicleDetailsDataSuccess(resp.data));
            store.dispatch(apiTransitionVehicleDetailsForm.success());
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionVehicleDetailsForm.failure());
        }
    })();
    return next(action);
};

const saveVehicleDetailsPayload = state => {
    const savedQuoteResponse = getApiQuoteResponse(state);
    const quoteId = savedQuoteResponse?.data?.quotation?.id;
    const carDetails = getCarDetailsForm(state);

    const payload = {
        quoteId,
        registrationNumber: carDetails.registrationNumber.value || "N/A",
        chassisNumber: carDetails.chasisNumber.value || 'N/A',
        tinNumber: carDetails.tinNumber.value || 'N/A',
        fuel_type: carDetails.fuelType.value || 'N/A'
    };

    // Change payload here
    return {
        ...payload
    };
};

const saveVehicleDetails = async state => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/save/vehicle-details';
        return await axios.post(url, saveVehicleDetailsPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa'
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
